//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useContext } from "react";

//import styles
import Context from 'context/context';
import { collapseComponentStyles } from "./style";

// material-ui
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Collapse from "@material-ui/core/Collapse";

//Helpers
import {pointsFormat, currencyFormat, tierRatioFormat} from "helpers/dataFormat"

export default function CollapseComponent(props) {
  const { state } = useContext(Context);
  const { open, headings, data, keys, language } = props;
  const classes = collapseComponentStyles();
  const [div, setDiv] = useState(false);
  const [index, setIndex] = useState(null);

  const commaFormat = (val) => {
    return val?.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
  }

  return (
    <TableRow>
      <TableCell className={classes.tabelCell} colSpan={12}>
        <Collapse
          in={open}
          timeout="auto"
          unmountOnExit
          style={{ border: "2px solid rgb(184 184 184)", borderRadius: 10 }}
        >
          <Table aria-label="purchases">
            <TableHead style={{ backgroundColor: "rgb(200 225 248)" }}>
              <TableRow>
                {headings.map((s, i) => (
                  <TableCell key={i} className={classes.subHeading}>
                    {s}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data &&
                data.length > 0 &&
                data.map((c, i) => (
                  <TableRow
                    key={i}
                    className={i % 2 === 0 ? classes.tableRow : ""}
                  >
                    {keys.map((k, j) => (
                      <TableCell
                        key={j}
                        className={classes.subData}
                        onMouseEnter={() => {
                          if (c[k]?.length > 30) {
                            setDiv(true);
                            setIndex(i);
                          }
                        }}
                        onMouseLeave={() => setDiv(false)}
                      >
                        <div title={c[k]?.length >= 30 ? c[k] : null}>
                          {c[k]?.length >= 30
                            ? `${c[k]?.slice(0, 27)}...`
                            :k === "points" ||
                            k === "points_redeemed" 
                              ? pointsFormat(c[k], language): k === "tier_ratio" ? tierRatioFormat(c[k], language)
                              : k == 'extended_sales_amount' || k == 'credit_issued' || k == 'purchase_value' || k === "credits_applied" ? currencyFormat(c[k], language, state?.userInfo?.loyalty_organization_name) : c[k]}
                        </div>
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </Collapse>
      </TableCell>
    </TableRow>
  );
}
